/**
 * @fileoverview class to setup communication via messenger to a host
 * and a domain.  We use this for iframe and popup communication currently
 * this may be moved to some sort of shared @mc-alberta package.
 */

import messenger from '@mc-alberta/messenger'

export default class Communicator {
  constructor (windowRef, domain) {
    this.window = windowRef
    this.domain = domain
  }

  send (name, payload = {}) {
    return messenger.send(this.window, name, payload, { domain: this.domain })
  }

  registerHandler (message, handler) {
    messenger.on(message, { window: this.window, domain: this.domain }, handler)
  }
}
